import React, {Component} from 'react';

import emailValidator from 'email-validator';

import styled from "styled-components";

import {sendContactUsRequest} from '../../helpers/common';
import analytics from "../../helpers/analytics";

import {Button, Input} from '../Controls'
import Modal from "../Modal";
import Loader from "../Loader";

import {ReactComponent as YesGreenIcon} from '../../assets/img/yes-green-icon.svg';

const StyledModal = styled(Modal)`
  max-width: 365px;
`;

const Form = styled.form`
  
  margin-bottom: 0;
  color: #000;
  
  h5 {
    margin-bottom: 5px;
    color: inherit;
  }
  
  input,
  textarea {
    margin-bottom: 10px;
  }
  
  button {
    width: 100%;
    margin-bottom: 10px;
  }
  
  p {
    margin-bottom: 0;
    font-size: 13px;
    line-height: 18px;
    color: rgba(46, 44, 71, 0.7);
  }

`;

const Phone = styled.div`
  
  margin-bottom: 10px;
  font-size: 14px;
  
  a {
    color: #0080e2;
  }
  
`;

const SuccessMsg = styled.div`

  display: flex;
  flex-direction: column;
  align-items: center;
  font-weight: bold;
  font-size: 15px;
  line-height: 23px;
  text-align: center;
  color: #000000;

  svg {
    width: 50px;
    height: 50px;
    margin-bottom: 20px;
  }

`;

class ContactUsModal extends Component {

  constructor(props, context) {

    super(props, context);

    this.deafaultState = {
      form: {
        email: {
          value: '',
          valid: true
        },
        name: {
          value: '',
          valid: true
        },
        message: {
          value: '',
          valid: true
        }
      },
      sending: false,
      error: false,
      wasSent: false,
    };

    this.state = this.deafaultState;

  }

  handleInputChange = (e) => {
    this.setState({
      form: {
        ...this.state.form,
        [e.target.name]: {
          ...this.state.form[e.target.name],
          value: e.target.value
        }
      }
    });
  };

  handleInputFocus = (e) => {
    this.setState({
      form: {
        ...this.state.form,
        [e.target.name]: {
          ...this.state.form[e.target.name],
          valid: true
        }
      }
    });
  };

  handleModalClose = () => {

    if (typeof this.props.onClose === 'function') {
      this.props.onClose();
    }

    if (this.state.wasSent || this.state.error) {
      this.setState(this.deafaultState)
    }

  };

  handleFormSubmit = async (e) => {

    e.preventDefault();

    let form = this.state.form,
      invalid = [];

    const {email, name, message} = form;

    if (!emailValidator.validate(email.value)) {
      invalid.push('email');
    }

    if (name.value.toString().trim() === "") {
      invalid.push('name');
    }

    if (message.value.toString().trim() === "") {
      invalid.push('message');
    }

    if (invalid.length > 0) {

      let form = this.state.form;

      invalid.forEach(key => {
        form = {
          ...form,
          [key]: {
            ...form[key],
            valid: false
          }
        }
      });

      this.setState({
        form
      });

      return;

    }

    this.setState({
      sending: true
    });

    try {

      await sendContactUsRequest(email.value, name.value, message.value);

      this.setState({
        wasSent: true
      });

      analytics.onContactModalSubmitted();

    } catch (e) {

      this.setState({
        error: true
      });

    } finally {

      this.setState({
        sending: false
      });

    }

  };

  render() {

    const {open} = this.props;
    const {error, sending, wasSent, form: {email, name, message}} = this.state;

    return (
      <StyledModal
        isOpen={open}
        onRequestClose={this.handleModalClose}
        sm
      >

        {error !== false &&
        <p>Sending Error</p>
        }

        {sending !== false &&
        <Loader/>
        }

        {error === false && sending === false && wasSent === false &&
        <Form onSubmit={this.handleFormSubmit}>

          <h5>Ruf'uns an oder schreibe eine E-Mail.</h5>

          <Phone>Telefon: <a href="tel:49592479830000">+49 5924 798300 00</a></Phone>

          <Input
            type="text"
            name="email"
            value={email.value}
            valid={email.valid}
            onChange={this.handleInputChange}
            onFocus={this.handleInputFocus}
            placeholder="E-Mail-Adresse *"
          />

          <Input
            type="text"
            name="name"
            value={name.value}
            valid={name.valid}
            onChange={this.handleInputChange}
            onFocus={this.handleInputFocus}
            placeholder="Vor-und Nachname *"
          />

          <Input
            as="textarea"
            name="message"
            value={message.value}
            valid={message.valid}
            onChange={this.handleInputChange}
            onFocus={this.handleInputFocus}
            placeholder="Deine Nachricht *"
          />

          <Button>Abschicken</Button>

          <p>
            Mit Klick auf den Button akzeptierst du unsere Datenschutzbedingungen.
          </p>

        </Form>
        }

        {wasSent === true &&
        <SuccessMsg>
          <YesGreenIcon/>
          Vielen Dank! Wir haben deine Nachricht erhalten und melden uns schnellstmöglich.
        </SuccessMsg>
        }


      </StyledModal>
    );
  }

}

export default ContactUsModal;
